import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate,useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ChevronDown } from "lucide-react";
import {
  FiCreditCard,
  FiTrendingUp,
  FiDollarSign,
  FiMinusCircle,
  FiArrowRightCircle,
  FiArrowRight,
  FiArrowLeft,
} from "react-icons/fi";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import dayjs from "dayjs";
import ThreeDotLoader from "../../Loader";
import Cookies from "js-cookie";


const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const Remittance = () => {
  const [dateRange, setDateRange] = useState("");
  const [category, setCategory] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [remited, setremited] = useState({});
  const [page, setPage] = useState(1); // Track current page
  const [limit, setLimit] = useState(20); // You can make this dynamic if needed
  const [loading, setLoading] = useState(true);
  const [remitedData, setremitedData] = useState([]);
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState("");
  const [userNameFilter, setUserNameFilter] = useState("");
  const [remittanceIdFilter, setRemittanceIdFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [utrFilter, setUtrFilter] = useState("");
  const [selectedRemittanceIds, setSelectedRemittanceIds] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const dateDropdownRef = useRef(null);
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [showSearchTypeDropdown, setShowSearchTypeDropdown] = useState(false);
  const [customDateLabel, setCustomDateLabel] = useState("");
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(statusFilter || "");
  const statusDropdownRef = useRef();
  const [customRange, setCustomRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const statusOptions = [
    // { value: "", label: "All Status" },
    { value: "Paid", label: "Paid" },
    { value: "Pending", label: "Pending" },
  ];
  const [isCustomApplied, setIsCustomApplied] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef();
  const { id } = useParams()
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
        setShowStatusDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleStatusSelect = (value) => {
    setStatusFilter(value);
    setSelectedStatus(value);
    setShowStatusDropdown(false);
  };

  const selectedLabel = statusOptions.find((opt) => opt.value === selectedStatus)?.label;
  const getDateRange = () => {
    const today = dayjs();

    switch (dateRange) {
      case "today":
        return {
          fromDate: today.startOf("day").toISOString(),
          toDate: today.endOf("day").toISOString(),
        };

      case "yesterday":
        return {
          fromDate: today.subtract(1, "day").startOf("day").toISOString(),
          toDate: today.subtract(1, "day").endOf("day").toISOString(),
        };

      case "last5days":
        return {
          fromDate: today.subtract(5, "day").startOf("day").toISOString(),
          toDate: today.endOf("day").toISOString(),
        };

      case "thisMonth":
        return {
          fromDate: today.startOf("month").toISOString(),
          toDate: today.endOf("month").toISOString(),
        };

      case "lastMonth":
        const lastMonth = today.subtract(1, "month");
        return {
          fromDate: lastMonth.startOf("month").toISOString(),
          toDate: lastMonth.endOf("month").toISOString(),
        };

      case "custom":
        if (isCustomApplied && customRange.length > 0) {
          return {
            fromDate: customRange[0].startDate.toISOString(),
            toDate: customRange[0].endDate.toISOString(),
          };
        }
        return {}; // Ignore if custom not applied

      default:
        return {};
    }
  };

  useEffect(() => {
    const remitancedata = async () => {
      setLoading(true);
      try {
        const token = Cookies.get("session");
        const { fromDate, toDate } = getDateRange();
        console.log("-----", fromDate, toDate);
        let url = `${REACT_APP_BACKEND_URL}/cod/codRemittanceData?page=${page}`;
        if (limit) url += `&limit=${limit}`;
        if (remittanceIdFilter)
          url += `&remittanceIdFilter=${remittanceIdFilter}`;
        if (utrFilter) url += `&utrFilter=${utrFilter}`;
        if (statusFilter) url += `&statusFilter=${statusFilter}`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;

        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params:{
            id
          }
        });
console.log("resososo datata:", response.data);
        if (response.data.success) {
          setremited(response.data.data);
          setremitedData(response.data.data.remittanceData);
          setTotalPages(response.data.totalPages);
        }
      } catch (error) {
        console.log("Error fetching remittance data:", error);
      } finally {
        setLoading(false);
      }
    };
    remitancedata();
  }, [
    refresh,
    remittanceIdFilter,
    utrFilter,
    statusFilter,
    dateRange,
    page,
    limit,
    category,
  ]);
  // When selecting from dropdown
  const onSelectDateRange = (value) => {
    if (value === "custom") {
      setShowDateDropdown(false); // Close dropdown first
      setTimeout(() => setShowCalendar(true), 0); // Delay to allow calendar to mount before checking outside click
    } else {
      setDateRange(value);
      setIsCustomApplied(false);
      setShowCalendar(false);
      setCustomDateLabel("");
      setShowDateDropdown(false);
    }
  };


  // When clicking Apply button inside calendar
  const handleApplyCustomDate = () => {
    setShowCalendar(false);
    const start = dayjs(customRange[0].startDate).format("MMM D");
    const end = dayjs(customRange[0].endDate).format("MMM D");

    setCustomDateLabel(`${start} - ${end}`);
    setDateRange("custom"); // Now set dateRange to custom
    setIsCustomApplied(true); // Mark that custom is applied
  };

  const handleDateRangeChange = (e) => {
    const value = e.target.value;

    // If the selected value is "custom"
    if (value === "custom") {
      // Toggle the calendar visibility
      setShowCalendar(!showCalendar);
    } else {
      setShowCalendar(false); // Hide calendar for other selections
    }

    setDateRange(value);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target)
      ) {
        setShowDateDropdown(false);
        setShowCalendar(false); // Safe to close here too
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  const RemittanceDetails = (id) => {
    navigate(`/dashboard/billing/RemittanceDetails/${id}`);
  };
  // Function to format date with day name
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };
  const handleCheckboxChange = (id) => {
    setSelectedRemittanceIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };
  const handleExport = async () => {
    try {
      const token = Cookies.get("session");

      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/cod/exportOrderInRemittance`,
        {
          params: { ids: selectedRemittanceIds },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const exportData = response.data.orders;

      const flattenedData = exportData.map((order) => ({
        "Order ID": order.orderId || "",
        "Courier Service": order.courierServiceName || "",
        "AWB Number": order.awb_number || "",
        "Payment Method": order.paymentMethod || "",
        "Payment Amount": order.paymentAmount || 0,
        "Delivery Date": order.deliveryDate || "",
      }));

      // Convert JSON to worksheet
      const worksheet = XLSX.utils.json_to_sheet(flattenedData);

      // Set column widths (width is approx. number of characters)
      worksheet["!cols"] = [
        { wch: 15 }, // Order ID
        { wch: 25 }, // Courier Service
        { wch: 20 }, // AWB Number
        { wch: 15 }, // Payment Method
        { wch: 18 }, // Payment Amount
        { wch: 25 }, // Delivery Date
      ];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Remittance Orders");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(
        data,
        `remittance_orders_${new Date().toISOString().slice(0, 10)}.xlsx`
      );
    } catch (error) {
      console.error("Export error:", error);
    }
  };

  return (
    <div className="">
      {/* Header Cards */}

      {/* Desktop View: grid */}
      <div className="hidden lg:grid grid-cols-5 gap-4 mb-2">
        {[
          {
            label: "COD To Be Remitted",
            value: `₹${(Number(remited?.CODToBeRemitted) || 0).toFixed(2)}`,
            icon: <FiCreditCard className="text-white" size={18} />,
          },
          {
            label: "Last COD Remitted",
            value: `₹${(Number(remited?.LastCODRemitted) || 0).toFixed(2)}`,
            icon: <FiArrowRightCircle className="text-white" size={18} />,
          },
          {
            label: "Total COD Remitted",
            value: `₹${(Number(remited?.TotalCODRemitted) || 0).toFixed(2)}`,
            icon: <FiTrendingUp className="text-white" size={18} />,
          },
          {
            label: "Total Deduction from COD",
            value: `₹${(Number(remited?.TotalDeductionfromCOD) || 0).toFixed(2)}`,
            icon: <FiMinusCircle className="text-white" size={18} />,
          },
          {
            label: "Remittance Initiated",
            value: `₹${(Number(remited?.RemittanceInitiated) || 0).toFixed(2)}`,
            icon: <FiDollarSign className="text-white" size={18} />,
          },
        ].map((card, index) => (
          <div
            key={index}
            className="border-2 border-[#632C9D] rounded-lg px-3 py-2 bg-white flex items-center gap-3"
          >
            <div className="flex-shrink-0 bg-[#632C9D] p-2 rounded-full">{card.icon}</div>
            <div className="flex flex-col">
              <div className="font-[600] text-[10px] text-gray-700">
                {card.value}
              </div>
              <div className="text-[10px] text-gray-500">{card.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile View: single box */}
      <div className="block lg:hidden border-2 border-[#632C9D] rounded-lg px-4 py-2 bg-white text-[12px] font-[600] text-gray-500 mb-2 space-y-1">
        {[
          { label: "COD To Be Remitted", value: remited?.CODToBeRemitted },
          { label: "Last COD Remitted", value: remited?.LastCODRemitted },
          { label: "Total COD Remitted", value: remited?.TotalCODRemitted },
          { label: "Total Deduction from COD", value: remited?.TotalDeductionfromCOD },
          { label: "Remittance Initiated", value: remited?.RemittanceInitiated },
        ].map((item, idx) => (
          <div
            key={idx}
            className="grid"
            style={{ gridTemplateColumns: "180px 10px 1fr" }}
          >
            <span className="truncate">{item.label}</span>
            <span className="text-center">:</span>
            <span className="text-right">₹{(Number(item.value) || 0).toFixed(2)}</span>
          </div>
        ))}
      </div>

      {/* filter data */}
      <div>
        <div className="flex gap-2 sm:flex-row w-full flex-col">
          {/* Search by Remittance ID */}
          <div className="flex gap-2">
            <input
              type="text"
              placeholder="Search by Remittance ID"
              className="w-full placeholder:text-gray-400 border-gray-300 md:w-[200px] h-9 px-3 text-[12px] font-[600] border-2 text-gray-700 rounded-lg focus:outline-none placeholder:text-[12px]"
              value={remittanceIdFilter}
              onChange={(e) => setRemittanceIdFilter(e.target.value)}
            />

            {/* Search by UTR */}
            <input
              type="text"
              placeholder="Search by UTR"
              className="w-full md:w-[200px] placeholder:text-gray-400 text-gray-700 border-gray-300 h-9 px-3 text-[12px] font-[600] border-2 rounded-lg focus:outline-none placeholder:text-[12px]"
              value={utrFilter}
              onChange={(e) => setUtrFilter(e.target.value)}
            />
          </div>

          <div className="flex gap-2 justify-between w-full">
            {/* Date and Status filter in one row on mobile */}
            <div className="flex gap-2 w-full">
              <div className="relative w-full sm:w-[140px]" ref={dateDropdownRef}>
                <button
                  onClick={() => setShowDateDropdown((prev) => !prev)}
                  className="w-full h-9 px-3 border-2 border-gray-300 rounded-lg font-[600] text-gray-400 text-left text-[12px] bg-white flex items-center justify-between"
                  type="button"
                >
                  {customDateLabel || "Dates"}
                  <ChevronDown
                    className={`w-4 h-4 transform transition-transform ${showDateDropdown ? "rotate-180" : ""
                      }`}
                  />
                </button>

                {showDateDropdown && (
                  <ul className="absolute z-30 w-full font-[600] text-gray-500 mt-1 bg-white border rounded-lg overflow-y-auto text-[12px]">
                    {[
                      { value: "today", label: "Today" },
                      { value: "yesterday", label: "Yesterday" },
                      { value: "last5days", label: "Last 5 Days" },
                      { value: "thisMonth", label: "This Month" },
                      { value: "lastMonth", label: "Last Month" },
                      {
                        value: "custom",
                        label: customDateLabel
                          ? `Custom: ${customDateLabel}`
                          : "Custom",
                      },
                    ].map((item) => (
                      <li
                        key={item.value || "default"}
                        className={`px-3 py-2 cursor-pointer hover:bg-gray-100 ${dateRange === item.value ? "bg-gray-100 font-medium" : ""
                          }`}
                        onClick={() => {
                          onSelectDateRange(item.value);
                          setDateRange(item.value);
                          setShowDateDropdown(false);
                          setShowCalendar(item.value === "custom");
                        }}
                      >
                        {item.label}
                      </li>
                    ))}
                  </ul>
                )}

                {showCalendar && (
                  <div
                    ref={calendarRef}
                    className="absolute z-50 mt-2 bg-white shadow-xl rounded-xl p-4 w-[300px] border border-gray-200"
                  >
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => setCustomRange([item.selection])}
                      moveRangeOnFirstSelection={false}
                      ranges={customRange}
                      maxDate={new Date()}
                      showDateDisplay={false}
                      className="text-[12px]"
                    />
                    <button
                      onClick={handleApplyCustomDate}
                      className="w-full mt-3 bg-[#632C9D] text-white text-sm py-2 rounded-lg hover:bg-[#0aaa6e] transition duration-150"
                    >
                      Apply
                    </button>
                  </div>
                )}
              </div>

              {/* Status Filter */}
              <div className="relative w-full sm:w-[140px]" ref={statusDropdownRef}>
                <button
                  onClick={() => setShowStatusDropdown((prev) => !prev)}
                  className="w-full h-9 px-3 border-2 border-gray-300 rounded-lg font-[600] text-gray-400 text-left text-[12px] bg-white flex items-center justify-between"
                  type="button"
                >
                  {/* {selectedLabel || "Select Status"} */}
                  {statusFilter === "" ? "Status" : selectedLabel}
                  <ChevronDown
                    className={`w-4 h-4 transform transition-transform ${showStatusDropdown ? "rotate-180" : ""}`}
                  />
                </button>

                {showStatusDropdown && (
                  <ul className="absolute z-30 w-full font-[600] text-gray-500 mt-1 bg-white border rounded-lg overflow-y-auto text-[12px]">
                    {statusOptions.map((item) => (
                      <li
                        key={item.value}
                        className={`px-3 py-2 cursor-pointer hover:bg-gray-100 ${selectedStatus === item.value ? "bg-gray-100 font-medium" : ""
                          }`}
                        onClick={() => handleStatusSelect(item.value)}
                      >
                        {item.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            {/* Buttons */}
            <div className="flex gap-2">
              <button
                className="flex items-center border-2 border-gray-100 justify-center md:justify-end bg-[#632C9D] text-white px-3 sm:h-9 py-2 rounded-lg text-[10px] sm:text-[12px] font-[600] hover:bg-[#0aa96f] transition-all duration-200"
                onClick={() => {
                  setRemittanceIdFilter("");
                  setUtrFilter("");
                  setStatusFilter("");

                  setDateRange("");
                  setCustomRange([
                    {
                      startDate: new Date(),
                      endDate: new Date(),
                      key: "selection",
                    },
                  ]);
                  setCustomDateLabel("");
                  setShowCalendar(false);
                }}
              >
                Clear
              </button>

              <button
                disabled={selectedRemittanceIds.length === 0}
                className={`flex items-center border-2 border-gray-100 justify-center ${selectedRemittanceIds.length === 0
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#632C9D]"
                  } text-white px-3 py-2 sm:h-9 rounded-lg text-[10px] sm:text-[12px] font-[600] transition-all duration-200 md:w-auto`}
                onClick={handleExport}
              >
                Export
              </button>
            </div>
          </div>
        </div>



        {/* Select All Checkbox on Mobile */}
        <div className="block sm:hidden mt-2">
          <div className="px-2 py-1 bg-purple-200 rounded-lg flex items-center gap-2">
            <input
              type="checkbox"
              checked={
                selectedRemittanceIds.length === remitedData.length &&
                remitedData.length > 0
              }
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedRemittanceIds(
                    remitedData.map((row) => row.remittanceId)
                  );
                } else {
                  setSelectedRemittanceIds([]);
                }
              }}
              className="cursor-pointer accent-[#632C9D] w-3"
            />
            <span className="text-[10px] font-[600] text-gray-500">Select All</span>
          </div>
        </div>
      </div>

      {/* px-3 py-2 bg-[#632C9D] text-white rounded-lg text-[12px] font-[600] */}
      <div className="hidden md:block relative mt-2">
        <table
          className="min-w-full 
         bg-white rounded-lg shadow-md table-auto"
        >
          {/* Table Head */}
          <thead>
            <tr className="text-white border border-[#632C9D] bg-[#632C9D] text-[12px] font-[600]">
              <th className="py-2 px-3 text-left">
                <div className="flex">
                  <input
                    type="checkbox"
                    checked={
                      selectedRemittanceIds.length === remitedData.length &&
                      remitedData.length > 0
                    }
                    onClick={(e) => {
                      if (e.target.checked) {
                        setSelectedRemittanceIds(
                          remitedData.map((row) => row.remittanceId)
                        );
                      } else {
                        setSelectedRemittanceIds([]);
                      }
                    }}
                    className="cursor-pointer accent-[#632C9D] w-3"
                  />
                  {/* <div className="ml-2">Date</div> */}
                </div>
              </th>
              <th className="py-2 px-3 text-left">Date</th>
              <th className="py-2 px-3 text-center" style={{ width: "150px", maxWidth: "200px" }}>Remittance ID</th>
              <th className="py-2 px-3 text-center" style={{ width: "80px", maxWidth: "130px" }}>UTR</th>
              <th className="py-2 px-3 text-center" style={{ width: "150px", maxWidth: "200px" }}>COD Available</th>
              <th className="py-2 px-3 text-center" style={{ width: "200px", maxWidth: "250px" }}>Amount Credited to Wallet</th>
              <th className="py-2 px-3 text-center" style={{ width: "150px", maxWidth: "200px" }}>Adjusted Amount</th>
              <th className="py-2 px-3 text-center" style={{ width: "150px", maxWidth: "200px" }}>Early COD Charges</th>
              <th className="py-2 px-3 text-center" style={{ width: "150px", maxWidth: "200px" }}>Remittance Amount</th>
              <th className="py-2 px-3 text-left">Remittance Method</th>
              <th className="py-2 px-3 text-left">Status</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="11" className="text-center py-6">
                  <ThreeDotLoader />
                </td>
              </tr>
            ) : remitedData.length > 0 ? (
              remitedData.map((row, index) => (
                <tr
                  key={index}
                  className="border hover:bg-gray-50 border-gray-300 text-gray-500 transition-all text-[12px] font-[400] relative"
                >
                  <td className="py-2 px-3 whitespace-nowrap">
                    <div className="flex">
                      <input
                        type="checkbox"
                        checked={selectedRemittanceIds.includes(
                          row.remittanceId
                        )}
                        onChange={() => handleCheckboxChange(row.remittanceId)}
                        className="cursor-pointer accent-[#632C9D] w-3"
                      />
                      {/* <div className="ml-2">{formatDate(row.date)}</div> */}
                    </div>
                  </td>
                  <td className="py-2 px-3 whitespace-normal" style={{ width: "150px", maxWidth: "200px" }}>{formatDate(row.date)}</td>
                  <td className="py-2 px-3 whitespace-normal" style={{ width: "150px", maxWidth: "200px" }}>
                    <div
                      onClick={() => RemittanceDetails(row.remittanceId)}
                      className="text-[#632C9D] font-[600] text-center hover:underline cursor-pointer"
                    >
                      {row.remittanceId}
                    </div>
                  </td>

                  <td className="py-2 px-3 whitespace-nowrap text-center" style={{ width: "80px", maxWidth: "130px" }}>
                    {row?.utr || "N/N"}
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap text-center" style={{ width: "150px", maxWidth: "200px" }}>
                    {`₹${(Number(row?.orderDetails?.codcal) || 0).toFixed(2)}`}
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap text-center" style={{ width: "200px", maxWidth: "250px" }}>
                    {`₹${(Number(row?.amountCreditedToWallet) || 0).toFixed(
                      2
                    )}`}
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap text-center" style={{ width: "150px", maxWidth: "200px" }}>
                    {`₹${(Number(row.adjustedAmount) || 0).toFixed(2)}`}
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap text-center" style={{ width: "150px", maxWidth: "200px" }}>
                    {`₹${(Number(row.earlyCodCharges) || 0).toFixed(2)}`}
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap text-center" style={{ width: "150px", maxWidth: "200px" }}>
                    {`₹${(Number(row.codAvailable) || 0).toFixed(2)}`}
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    {row.remittanceMethod}
                  </td>
                  <td
                    className={`py-2 px-3 whitespace-nowrap`}
                  >
                    <p className={`text-[10px] px-2 py-1 rounded-lg text-center font-[600] ${row.status === "Paid"
                      ? "text-[#632C9D] bg-purple-200"
                      : row.status === "Pending"
                        ? "text-orange-500 bg-orange-200"
                        : ""
                      }`}>{row.status}</p>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="text-center py-4 text-gray-500">
                  No orders found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile View */}
      <div className="md:hidden space-y-2">
        {remitedData.map((row, index) => (
          <div
            key={index}
            className="bg-purple-100 shadow-md text-gray-500 rounded-lg p-3 mt-2"
          >
            <div className="mt-2">
              <div className="flex justify-between">
                <div className="flex text-[10px] font-[400]">
                  <input
                    type="checkbox"
                    checked={selectedRemittanceIds.includes(row.remittanceId)}
                    onChange={() => handleCheckboxChange(row.remittanceId)}
                    className="cursor-pointer accent-[#632C9D] w-3 h-3"
                  />
                  <p className="ml-2">Date:</p>
                  <p className="text-gray-500 ml-2">{formatDate(row.date)}</p>
                </div>
                <div>
                  <p className="text-[#632C9D] text-[10px] font-[400]">
                    {" "}
                    {row.status}
                  </p>
                </div>
              </div>
              <div className="flex">
                <p className="text-[10px] font-[400] ml-5">Remittance ID:</p>
                <p
                  className="ml-2 text-[10px] font-[400] text-[#632C9D] hover:underline"
                  onClick={() => RemittanceDetails(row.remittanceId)}
                >
                  {row.remittanceId}
                </p>
              </div>
              <div className="flex">
                <p className="text-[10px] font-[400] ml-5">UTR:</p>
                <p className="ml-2 text-[10px] font-[400] text-gray-500">
                  {row.utr}
                </p>
              </div>
              <div className="mt-2 bg-white rounded-lg p-3 text-[10px] font-[400]">
                {/* Individual amounts */}
                <div className="flex justify-between items-center">
                  <p className="text-gray-700 text-[10px] font-[400] text-left">
                    Total COD:
                  </p>
                  <p className="text-right text-[#632C9D]">{`₹${(
                    row.amountCreditedToWallet +
                    row.earlyCodCharges +
                    row.adjustedAmount +
                    row.codAvailable
                  ).toFixed(2)}`}</p>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500">-</span>
                  <p className="text-[10px] font-[400] text-gray-500 text-left flex-1 pl-2">
                    Amount Credited to Wallet:
                  </p>
                  <p className="text-right text-red-600">{`₹${(
                    row.amountCreditedToWallet || 0
                  ).toFixed(2)}`}</p>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500">-</span>
                  <p className="text-[10px] font-[400] text-gray-500 text-left flex-1 pl-2">
                    Early COD Charges:
                  </p>
                  <p className="text-right text-red-600">{`₹${(
                    row.earlyCodCharges || 0
                  ).toFixed(2)}`}</p>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 ">-</span>
                  <p className="text-[10px] font-[400] text-gray-500 text-left flex-1 pl-2">
                    Adjusted Amount:
                  </p>
                  <p className="text-right text-red-600">{`₹${(
                    row.adjustedAmount || 0
                  ).toFixed(2)}`}</p>
                </div>
                {/* Divider */}
                <div className="border-t my-1"></div>

                {/* Total */}
                <div className="flex justify-between items-center">
                  <p className="text-left text-[12px] font-[400]">
                    {" "}
                    COD Available:
                  </p>
                  <p className="text-right text-[#632C9D]">{`₹${(
                    row.codAvailable || 0
                  ).toFixed(2)}`}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="flex justify-between items-center mt-6 gap-4 flex-wrap text-[10px] font-[600]">
        <div className="flex items-center gap-2">
          <label
            htmlFor="limit"
            className="text-gray-700 text-[10px] font-[600]"
          >
            Show:
          </label>
          <select
            id="limit"
            value={limit}
            onChange={(e) => {
              const selected = e.target.value;
              if (selected === "All") {
                setLimit(null); // null means no limit
                setPage(1);
              } else {
                setLimit(parseInt(selected));
                setPage(1); // reset to first page when changing limit
              }
            }}
            className="px-3 py-2 border rounded-md text-[10px] font-[600]"
          >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={75}>75</option>
            <option value={100}>100</option>
            <option value="All">All</option>
          </select>
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            disabled={page === 1}
            className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
          >
            <FiArrowLeft />
          </button>
          <span className="text-gray-700">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={page === totalPages}
            className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
          >
            <FiArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Remittance;